module.exports = __webpack_public_path__ + "img/1.48cb03a7.png";